export const REFRESH_BASE_INFO = 'refreshBaseInfo'
export const SET_CUR_MSG = 'setCurMsg'
export const SET_LOADING_INFO = 'setLoadingInfo'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js